import { Vector as VectorSource } from 'ol/source';
import GeoJSON from 'ol/format/GeoJSON';
import config  from '../config';
import { getGeoJSON } from '../librairies';


const FormationPluridisciplinaire = async () => {
	var source = await fetch(config.serveur+`SELECT id,  ST_asGeojson(ST_Transform(geom,3857)) AS geom,thematique, nom,texte,adresse,cp,ville,url,photo FROM websig.esport WHERE thematique = 'Formation pluridisciplinaire'`);
	var source1 = getGeoJSON(await source.json());

	return new VectorSource({
		features: new GeoJSON().readFeatures(source1),
	});
}

export default FormationPluridisciplinaire;